import { Injectable, signal, computed } from '@angular/core';
import type { EntityTreePickerSelection } from './entity-tree-picker.types';

/**
 * Imperatives Open-Pattern für den Entity-Tree-Picker — analog T2dConfirmDialogService.
 * Voraussetzung: <t2d-entity-tree-picker-host /> einmalig im Default-Layout gemountet.
 *
 * @example
 * const sel = await this.treePicker.open();
 * if (!sel) return; // abgebrochen
 * // ... sel.entityType / sel.entityId / sel.label verwenden
 */
@Injectable({ providedIn: 'root' })
export class T2dEntityTreePickerService {
  private readonly _open = signal(false);
  readonly isOpen = computed(() => this._open());

  private resolver: ((value: EntityTreePickerSelection | null) => void) | null = null;

  open(): Promise<EntityTreePickerSelection | null> {
    // Offenen Vorgänger abbrechen (mit null auflösen)
    if (this.resolver) this.resolver(null);
    this._open.set(true);
    return new Promise<EntityTreePickerSelection | null>((resolve) => {
      this.resolver = resolve;
    });
  }

  /** Vom Host aufgerufen: Auswahl übernehmen oder (null) abbrechen. */
  resolve(value: EntityTreePickerSelection | null): void {
    const r = this.resolver;
    this.resolver = null;
    this._open.set(false);
    r?.(value);
  }
}
